module.exports = __webpack_public_path__ + "media/images/pic/saska/team/teachers/anna-adamczyk-rucel-fc9cf5666156b15d49ea7ce698d450d4.png";